import request from '../../request'

export default {
  actions: {
    // list all products
    getNotifications(_, parameters) {
      return request.get('notification', {
        params: parameters
      })
    },


    deleteNotification(_, id) {
      return request.delete('notification/' + id)
    },

  }
}
